import colors from './colors'

export * from './strings'
export * from './events'
export * from './times'
export * from './csv'
export * from './functions'
export * from './coordenadas-remedios'
export { colors }



// WEBPACK FOOTER //
// ./src/utils/index.js